// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import ScrollToBottomToast from './scroll_to_bottom_toast';

export default ScrollToBottomToast;
